import { render } from "./MiniMainMenu.vue?vue&type=template&id=272da83e"
import script from "./MiniMainMenu.vue?vue&type=script&lang=js"
export * from "./MiniMainMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__